export default __webpack_public_path__ + "static/media/foie_thumb.b1eea9f6.jpg";